/**
 * @typedef {import("../custom-elements/vi-carousel").default} ViCarousel
 */

class MTeaserCarousel {
	#defaultColorBackground;

	#defaultColorContent;

	/** @param {HTMLElement} element */
	constructor(element) {
		this.element = element;
		/** @type {ViCarousel} */
		this.carouselElement = element.querySelector('vi-carousel');

		this.#defaultColorContent = element.style.getPropertyValue('--_color-content');
		this.#defaultColorBackground = element.style.getPropertyValue('--_color-background');

		this.carouselElement?.addEventListener('index-changed', (event) => {
			/** @type {null|HTMLElement} */
			const mCarouselItemElement = event.detail?.currentElement?.querySelector('.m-carousel-item');
			if (mCarouselItemElement) {
				element.style.setProperty('--_color-content', mCarouselItemElement.dataset.colorContent ?? this.#defaultColorContent);
				element.style.setProperty('--_color-background', mCarouselItemElement.dataset.colorBackground ?? this.#defaultColorBackground);
			}
		});
	}
}

document.querySelectorAll('.m-teaser-carousel').forEach((_) => new MTeaserCarousel(_));
